import React, { useState } from "react";
import { Outlet, Link, useNavigate } from "react-router-dom";
import "../Dashboard/styles.css";
import "bootstrap/dist/css/bootstrap.min.css";

function MobileMenuContainer() {
  const [navVisible, setNavVisible] = useState(false);
  const [usersDropdownOpen, setUsersDropdownOpen] = useState(false);
  const [packagesDropdownOpen, setPackagesDropdownOpen] = useState(false);

  const toggleNav = () => {
    setNavVisible(!navVisible);
  };

  const navigate = useNavigate();

  const handleLogout = () => {
    console.log("Logging out...");
    localStorage.removeItem('loggedInUser');
    navigate('/');
  };

  const toggleUsersDropdown = () => {
    setUsersDropdownOpen((prevState) => !prevState);
  };

  const togglePackagesDropdown = () => {
    setPackagesDropdownOpen((prevState) => !prevState);
  };

  return (
    <>
      <div className="dashboard-navigation">
        <div className="container">
          <div className={`navbar-collapse ${navVisible ? "show" : ""}`}>
            <ul className="navbar-nav">
              <li className="nav-item">
                <Link
                  to="/Dashboard"
                  className="nav-link"
                  activeClassName="active-menu"
                >
                  <i className="far fa-chart-bar"></i> Dashboard
                </Link>
              </li>
              <li className="nav-item">
                <div
                  className="nav-link dropdown-toggle"
                  onClick={toggleUsersDropdown}
                >
                  <i className="fas fa-user"></i> Users
                </div>
                {usersDropdownOpen && (
                  <ul className="sub-menu">
                    <li className="nav-item">
                      <Link
                        to="/Dashboard/users"
                        className="nav-link"
                        activeClassName="active-menu"
                      >
                        User List
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        to="/Dashboard/users/edit"
                        className="nav-link"
                        activeClassName="active-menu"
                      >
                        Admin List
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        to="/Dashboard/users/new"
                        className="nav-link"
                        activeClassName="active-menu"
                      >
                        Admin Registration
                      </Link>
                    </li>
                  </ul>
                )}
              </li>
              <li className="nav-item">
                <div
                  className="nav-link dropdown-toggle"
                  onClick={togglePackagesDropdown}
                >
                  <i className="fas fa-hotel"></i> Packages
                </div>
                {packagesDropdownOpen && (
                  <ul className="sub-menu">
                    <li className="nav-item">
                      <Link
                        to="/Dashboard/package"
                        className="nav-link"
                        activeClassName="active-menu"
                      >
                        Add Package
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        to="/Dashboard/package/active"
                        className="nav-link"
                        activeClassName="active-menu"
                      >
                        Active Packages
                      </Link>
                    </li>
                  </ul>
                )}
              </li>
              <li className="nav-item ps-2 pb-2">
                <button
                  className="nav-link"
                  activeClassName="active-menu"
                  onClick={handleLogout}
                >
                  <i className="fas fa-sign-out-alt"></i> Logout
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <Outlet />
    </>
  );
}

export default MobileMenuContainer;
